module.exports = __webpack_public_path__ + "static/img/list_cg_h.755f0247.png";